@if(pdfPreviewUrl != undefined){
<div class="invoice-view-shell">
    <div class="invoice-view-toolbar">
        <div class="invoice-view-title">
            <strong>Invoice {{ invoiceNumber }}</strong>
        </div>
        <button type="button" class="btn btn-primary ace-blue" (click)="downloadInvoicePdf()" [disabled]="pdfBlob == undefined">
            Download PDF
        </button>
    </div>

    <div class="invoice-view-frame">
        <iframe
            [src]="pdfPreviewUrl"
            frameBorder="0"
            scrolling="auto"
            height="100%"
            width="100%"
        ></iframe>
    </div>
</div>
}
@else {
    <div class="loading-wrap">
        <div class="loading-content">
            <mat-progress-bar class="invoice-progress" mode="indeterminate"></mat-progress-bar>
            <span class="loading-label"><strong>Preparing Invoice...</strong></span>
        </div>
    </div>
}